/**
 * Turn an i18n-keyed option set into DS `{ value, label }` options.
 *
 * Module-level on purpose: a local closure inside a component makes
 * `react-hooks/preserve-manual-memoization` bail out, because the compiler
 * cannot prove the callback's dependencies. Taking `t` as an argument keeps the
 * `useMemo` deps honest.
 *
 * @param {{ value: string, labelKey: string }[]} options
 * @param {(key: string) => string} t
 */
export function translateFilterOptions(options, t) {
  return options.map(({ value, labelKey }) => ({ value, label: t(labelKey) }));
}
